import { useClient } from 'hooks/useClient';
import { ISignaturePostMetadata } from '@cincel/client';
import { useMutation } from 'react-query';
import { resolveTokenV3 } from 'helpers/sessionContext';
// import { useToast } from '@chakra-ui/react';
// import { ERROR_TOAST_DEFAULTS } from '@helpers';
import { useCallback } from 'react';
// import { translations } from 'translations';
// import { useTranslation } from 'react-i18next';
import { useSession } from 'store/session';
import { AxiosError } from 'axios';

export const usePostSignature = ({ token }) => {
  const client = useClient({
    token: resolveTokenV3(token),
    url: process.env.REACT_APP_API_V3,
  });

  // const toast = useToast();

  const { team: currentTeam } = useSession();

  // const { t } = useTranslation();

  const teamUUID = currentTeam?.uuid as string;

  const fn = async (payload: ISignaturePostMetadata) => {
    const { folderId, documentId, invite, team, image, headers } = payload;

    if (typeof team === 'undefined' || !team) throw new Error('NO_TEAM');

    const response = await client.signDocumentV3(
      team ?? teamUUID,
      folderId,
      documentId,
      invite,
      image,
      headers,
    );
    return response;
  };

  const onError = useCallback((error: AxiosError) => {
    console.error(error);
  }, []);

  const mutation = useMutation('post-document-signature', fn, { onError });

  return { ...mutation };
};
